export const getCurrentUser = store => store.session?.data?.user;

export const isDemystUser = store => Boolean(store.session?.data?.organization?.is_demyst_org);

export const isDemystAdmin = (store) => {
  const user = store.session?.data?.user;
  return Boolean(isDemystUser(store) && user?.role?.description === "Admin");
};
